import "../../../css/ProfileSkeleton.css";

export default function ProfileSkeleton() {
    return (
        <div className="profile-skeleton-wrapper">
            <div className="profile-skeleton">

                {/* Header */}
                <div className="skeleton-header">
                    <div className="skeleton-cover">
                        <div className="skeleton-avatar"></div>
                    </div>
                </div>

                {/* Profile info */}
                <div className="skeleton-row">
                    <div className="skeleton-line label"></div>
                    <div className="skeleton-line value"></div>
                </div>

                <div className="skeleton-row">
                    <div className="skeleton-line label"></div>
                    <div className="skeleton-line value"></div>
                </div>

                {/* POSTS GRID */}
                <div className="skeleton-post-grid">
                    <div className="skeleton-post-card"></div>
                    <div className="skeleton-post-card"></div>
                </div>
            </div>
        </div>
    );
}
